import script from "./Driving-card-design.vue?vue&type=script&setup=true&lang=js"
export * from "./Driving-card-design.vue?vue&type=script&setup=true&lang=js"

import "./Driving-card-design.vue?vue&type=style&index=0&id=95cfa704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95cfa704"]])

export default __exports__